import gql from "graphql-tag";

export const getPrice = gql`
  query Query {
    GetPrice
  }
`;
export const getCheckOutSession = gql`
  query Query($priceId: String!, $userId: String!) {
    GetCheckOutSession(priceId: $priceId, userId: $userId)
  }
`;
export const subscriptionCancelQuery = gql`
  query Query {
    getCancelSubscription
  }
`;

// export const subscriptionHistory = gql`
//   query Card {
//     getUserPaymentHistory {
//       planInfo {
//         amount
//         currency
//         planId
//         planName
//         planType
//       }
//       method
//       razorpay_payment_id
//       razorpay_subscription_id
//       updatedAt
//       createdAt
//       userId
//       card {
//         created_at
//         endTime
//         entity
//         last4
//         name
//         network
//         type
//       }
//       upi {
//         upi_id
//         vpa
//         upi_name
//         acquirer_data {
//           rrn
//           upi_transaction_id
//         }
//         created_at
//         endTime
//       }
//     }
//   }
// `;

export const subscriptionHistory = gql`
  query GetTokenPaymentHistory {
    getTokenPaymentHistory {
      _id
      card {
        created_at
        current_end
        endTime
        entity
        id
        last4
        name
        network
        type
      }
      createdAt
      method
      order_id
      paidCount
      planInfo {
        amount
        currency
        planId
        planName
        planType
      }
      razorpay_payment_id
      razorpay_subscription_id
      updatedAt
      upi {
        acquirer_data {
          rrn
          upi_transaction_id
        }
        created_at
        current_end
        endTime
        upi_id
        upi_name
        vpa
      }
      userId
    }
  }
`;

export const userSubscriptionData = gql`
  query GetUserSubscriptionDetails {
    getUserSubscriptionDetails {
      _id
      blogGeneration
      keywordRanking
      keywordResearch
      projects
      siteAudit
      subscriptionType
      totalSiteAudit
      totalProjects
      totalBlogGeneration
      totalKeywordResearch
      totalKeywordRanking
      totalAiBlogGenerate
      userId
      aiBlogGenerate
    }
  }
`;
